module.exports = __webpack_public_path__ + "img/success.42f29eca.gif";